import { formatDistanceToNow } from "date-fns";
import * as locale from "date-fns/locale";

export function relativeTime(date: Date): string {
  const lang = window.localStorage.getItem("lang");
  const distance = formatDistanceToNow(date, { locale: lang === 'en' ? locale.enUS : locale.zhCN });
  return distance;
}
